import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import StepComponent from 'components/StepComponent/CustomSteps';
import { getStepsRiskExposure } from 'constants/inventorySteps';

const ICTRiskExposureSteps: React.FC = () => {
  const [current, setCurrent] = useState(0);
  const { t } = useTranslation();

  const stepsRiskExposure = getStepsRiskExposure(t);

  const title = stepsRiskExposure[current]?.title;

  return (
    <StepComponent
      steps={stepsRiskExposure}
      current={current}
      onStepChange={setCurrent}
      title={title}
    />
  );
};

export default ICTRiskExposureSteps;
